<template>
  <div id="app">
      <index/>
  </div>
</template>

<script>
import Index from './pages/index.vue'

export default {
  name: 'App',
  components: {
    Index
  }
}
</script>

<style lang="less">
@import '../../assets/css/reset.less';
#app {
  font-family: "Open Sans", Arial, "Hiragino Sans GB", "Microsoft YaHei", STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}
body {
  // background: #212f2d url(../../assets/images/pc/bg.png) repeat center center;
  background-color: #000000;
  background-size: auto 540px;
  color: #333;
}
</style>